import { render, staticRenderFns } from "./EmployeeSalaryVat.vue?vue&type=template&id=55c868f4&"
import script from "./EmployeeSalaryVat.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalaryVat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports